module.exports = __webpack_public_path__ + "static/img/whiteLogo.e922278.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/whiteLogo.png
// module id = g3/0
// module chunks = 1